module.exports = __webpack_public_path__ + "static/media/parent_notification_icon1.e428705b.svg";